/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'file/txt': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M4 .25A1.75 1.75 0 002.25 2v8.602h1.5V2A.25.25 0 014 1.75h10.75v4.606c0 .966.784 1.75 1.75 1.75h3.75v2.496h1.5V7.356a.75.75 0 00-.183-.491l-5.5-6.356A.75.75 0 0015.5.25H4zm15.36 6.356l-3.11-3.593v3.343c0 .138.112.25.25.25h2.86zM3.75 14.172a.25.25 0 01.25-.25h16a.25.25 0 01.25.25V22a.25.25 0 01-.25.25H4a.25.25 0 01-.25-.25v-7.828zm.25-1.75a1.75 1.75 0 00-1.75 1.75V22c0 .966.784 1.75 1.75 1.75h16A1.75 1.75 0 0021.75 22v-7.828a1.75 1.75 0 00-1.75-1.75H4zM9.18 17.4h.71v-.735H7.603v.735h.71V20h.865v-2.6zm2.248.82L10.123 20h1.045l.75-1.085.71 1.085h1.05l-1.26-1.78 1.085-1.555h-1.065l-.515.865-.495-.865h-1.07l1.07 1.555zm4.06-.82h.71v-.735h-2.286v.735h.71V20h.865v-2.6z" _fill="#000"/>'
  }
})
